import { Flex } from '@chakra-ui/react';
import { Text } from '@diamond/shared/ui';

import { VoucherIcon } from './icons';

interface VoucherAvailableBadgeProps {
  label?: string;
}

export function VoucherAvailableBadge({
  label = 'Voucher tersedia',
}: VoucherAvailableBadgeProps) {
  return (
    <Flex
      display="inline-flex"
      align="center"
      gap="1.25"
      h="28px"
      px="2.5"
      borderRadius="6px"
      bg="#F2F5FF"
      color="#0000A3"
      maxW="fit-content"
      whiteSpace="nowrap"
    >
      <VoucherIcon w="14px" h="14px" minW="14px" />
      <Text
        color="inherit"
        fontSize="xs"
        fontWeight="500"
      >
        {label}
      </Text>
    </Flex>
  );
}
